import { AfterViewChecked, ChangeDetectorRef, Component, HostBinding, Inject, Input, OnDestroy } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';

import { NavigationRouterService } from '../../../../../lib/navigation/navigation-router.service';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../base/services/betslip-messages-provider.service';
import { IBetslipRootState } from '../../../../base/store/state';
import { BetslipType } from '../../../../core/betslip-type';
import { BetslipPick } from '../../../../core/picks/betslip-pick';
import { ResultStatus } from '../../../../core/picks/pick-models';
import BaseBetTypePickComponent from '../../../picks/components/digital/base-bet-type-pick.component';
import BetslipPickUtilsService from '../../../picks/services/betslip-pick-utils.service';
import PickTypeSelectorService from '../../../picks/services/pick-type-selector.service';
import { IPickUiState } from '../../../picks/state';
import { EditBetActions } from '../../actions';
import { IEditMyBetPickState } from '../../state';

@Component({
    selector: 'bs-edit-bet-pick',
    templateUrl: './edit-bet-pick.component.html',
    styleUrls: ['../../../picks/components/digital/base-bet-type-pick.component.scss', './edit-bet-pick.component.scss'],
    standalone: false,
})
export default class EditBetPickComponent extends BaseBetTypePickComponent implements AfterViewChecked, OnDestroy {
    @HostBinding('class') className = 'betslip-digital-pick betslip-combo-bet-pick';

    @Input() override pick: BetslipPick;
    @Input() pickState: IEditMyBetPickState;
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() pickUiState: IPickUiState;
    pickStyle: string;
    resultedStateEnum = ResultStatus;

    @HostBinding('class.betslip-pick__edit-bet-removed') override get open(): boolean {
        return !!this.pickState && this.pickState.isRemoved;
    }

    @HostBinding('class.betslip-pick__settled') override get closed(): boolean {
        return !!this.pickState && this.pickState.resultedState !== ResultStatus.Open;
    }

    readonly betslipType = BetslipType.EditBet;

    constructor(
        protected override store: Store<IBetslipRootState>,
        pickTypeSelector: PickTypeSelectorService,
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService,
        navigationRouter: NavigationRouterService,
        redirectHelper: RedirectHelperService,
        public siteCore: Sitecore,
        changeDetectorRef: ChangeDetectorRef,
        betslipPickUtilsService: BetslipPickUtilsService,
    ) {
        super(store, pickTypeSelector, messageProvider, navigationRouter, redirectHelper, changeDetectorRef, betslipPickUtilsService);
    }

    override ngAfterViewChecked(): void {
        this.startRemoveTimer$.next(this.pickUiState.highlightPick || this.hasHighlight);
    }

    override removePick(): void {
        this.store.dispatch(EditBetActions.removePick({ pickId: this.pick.id.toString() }));
    }

    enablePick(): void {
        this.store.dispatch(EditBetActions.startUndoingRemovePick({ pickId: this.pick.id.toString() }));
    }
}
